module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "columns",
    attrs: {
      "id": "contact"
    }
  }, [_c('div', {
    staticClass: "column"
  }, [_c('h2', {
    staticClass: "subtitle"
  }, [_vm._v("PowerNine Games")]), _vm._v(" "), _c('address', [_vm._v("\n      341 State Street"), _c('br'), _vm._v("\n      Madison, WI 53703"), _c('br'), _vm._v("\n      United States"), _c('br'), _c('br'), _vm._v(" "), _c('a', {
    attrs: {
      "href": "tel:+16082516140"
    }
  }, [_vm._v("608-251-6140")]), _c('br'), _vm._v(" "), _c('a', {
    attrs: {
      "href": "mailto:PowerNine.com@gmail.com"
    }
  }, [_vm._v("PowerNine.com@gmail.com")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7460a685"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Contact.vue
// module id = 498
// module chunks = 1